import * as Turbo from '@hotwired/turbo'
import ahoy from 'ahoy.js'
import CookieConsent from './_dist/cookie_consent.js'
import * as FloatingUIDOM from '@floating-ui/dom'
import './_dist/swiper-bundle.min.js'
import './_dist/simple-lightbox.min.js'

Turbo.start()
document.addEventListener("turbo:load", onLoad);

function setActiveTab(tabContainer, index) {
    let tabsContent = tabContainer.querySelector('.tabs-content');

    if (tabsContent) {
        let tabs = tabContainer.querySelectorAll('.tab');
        let tabNavigationItems = tabContainer.querySelectorAll('.tab-navigation li');

        if (tabs.length > 0) {
            let activeIndex = 0;
            let valid = true;
            let multistep = tabContainer.classList.contains('is--multistep');

            tabs.forEach(tab => {
                tab.classList.contains('is--active') ? activeIndex = Array.from(tabs).indexOf(tab) : null;
            });

            if (typeof index === 'string') {
                if (multistep === true && index === 'next') {
                    let requiredFormItems = tabs[activeIndex].querySelectorAll('.form-item.is--required');

                    requiredFormItems.forEach(requiredFormItem => {
                        let input = requiredFormItem.querySelector('input, select, textarea');
                        if (input) {
                            validateFormItem(input, true) === false ? valid = false : null;
                        }
                    });
                }

                if (valid === true) {
                    index === 'prev' ? activeIndex-- : activeIndex++;
                }
            } else {
                activeIndex = index;
            }

            if (multistep === true) {
                if (activeIndex < 0) {
                    activeIndex = 0;
                } else if (activeIndex >= tabs.length) {
                    activeIndex = tabs.length - 1;
                }
            } else {
                if (activeIndex < 0) {
                    activeIndex = tabs.length - 1;
                } else if (activeIndex >= tabs.length) {
                    activeIndex = 0;
                }
            }

            tabs.forEach((tab, i) => {
                if (i === activeIndex) {
                    tab.classList.add('is--active');
                    tab.removeAttribute('hidden');
                } else {
                    tab.classList.remove('is--active');
                    tab.setAttribute('hidden', true);
                }
            });

            tabNavigationItems.forEach((tabNavigationItem, i) => {
                let tabNavigationLink = tabNavigationItem.querySelector('a');

                if (i === activeIndex) {
                    tabNavigationItem.classList.add('is--active');
                } else {
                    tabNavigationItem.classList.remove('is--active');
                }

                if (multistep === true) {
                    if (i <= activeIndex) {
                        tabNavigationItem.classList.remove('is--disabled');
                    }
                }

                tabNavigationLink.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
            });

            // tabsContent.style.transform = 'translateX(-' + activeIndex * 100 + '%)';
        }
    }
}

function updateAnalytics() {
  if (window.cc.acceptedCategories.indexOf('analytics') == -1) return false

  ahoy.configure({
    visitsUrl: "/poll/visits",
    eventsUrl: "/poll/events",
    cookies: true,
    visitParams: {},
  });

  ahoy.trackView();
  ahoy.trackClicks("a, button, input[type=submit]");
  ahoy.trackSubmits("form");

  const domainGtag = document.getElementsByName("gtag")[0].content
  if (domainGtag) {
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', domainGtag);
  }

  const domainGtmId = document.getElementsByName("gtm_id")[0].content
  if (domainGtmId) {
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer',domainGtmId);
  }

  const domainMetaPixel = document.getElementsByName("meta_pixel")[0].content
  if (domainMetaPixel) {
    if (typeof fbq !== "undefined") fbq('init', domainMetaPixel);
    if (typeof fbq !== "undefined") fbq('track','PageView');
  }
}

window.buildTooltip = () => {
    let tooltips = document.querySelectorAll('.tooltip');

    if (tooltips) {
        tooltips.forEach(tooltip => {
            let tooltipIcon = tooltip.querySelector('.btn');
            let tooltipWrapper = tooltip.querySelector('.tooltip-wrapper');

            if (tooltipIcon && tooltipWrapper) {
                let position = tooltip.dataset.position || 'top';
                let initalMaxWidth = parseInt(getComputedStyle(tooltipWrapper).maxWidth) || 300;
                let totoltipCloseBtn = tooltipWrapper.querySelector('.btn.is--toggle');

                tooltipIcon.addEventListener('click', () => {
                    tooltip.classList.toggle('is--active');
                })

                totoltipCloseBtn.addEventListener('click', () => {
                    tooltip.classList.toggle('is--active');
                })

                tooltip.floatingUI?.();
                tooltip.floatingUI = FloatingUIDOM.autoUpdate(tooltipIcon, tooltipWrapper, () => {
                    FloatingUIDOM.computePosition(tooltipIcon, tooltipWrapper, {
                        placement: position,
                        middleware: [
                            FloatingUIDOM.offset(16),
                            FloatingUIDOM.flip(),
                            FloatingUIDOM.size({
                                apply({ availableWidth, elements }) {
                                    Object.assign(elements.floating.style, {
                                        maxWidth: `${Math.max(0, (availableWidth - 16 > initalMaxWidth ? initalMaxWidth : availableWidth - 16))}px`,
                                    });
                                },
                            }),
                        ],
                    }).then(({ x, y, placement }) => {
                        tooltip.dataset.position = placement;
                        Object.assign(tooltipWrapper.style, {
                            top: `${y}px`,
                            left: `${x}px`,
                        });
                    });
                });
            }
        });
    }


}


function onLoad() {

  window.addEventListener('click', (e) => {
    let interactionToggleElement = e.target.closest('.interaction--toggle');
    let nav = e.target.closest('nav');
    let interactionNavigationElement = e.target.closest('.interaction--navigation');
    let tabNavigationLink = e.target.closest('.tab-navigation a');
    let gallery = e.target.closest('.gallery');

    if (interactionNavigationElement) {
        let direction = interactionNavigationElement.classList.contains('is--next') ? 'next' : 'prev';

        if (direction) {
            let tabs = e.target.closest('.tabs');

            // corrected 08.04.2025
            if (!e.target.closest('.slider') && !e.target.closest('.gallery')) {
                if (tabs) {
                    setActiveTab(tabs, direction);
                } else {
                    direction === 'next' ? window.history.forward() : window.history.back();
                }
            }
        }

    } else if (tabNavigationLink) {
        let tabs = e.target.closest('.tabs');

        e.preventDefault();

        if (tabs) {
            let tabNavigationLinks = tabs.querySelectorAll('.tab-navigation a');

            if (tabNavigationLinks.length > 0) {
                let index = Array.from(tabNavigationLinks).indexOf(tabNavigationLink);

                setActiveTab(tabs, index);
            }
        }
    } else if (gallery) {
        let slider = gallery.querySelector('.slider');
        let clickedFilterButton = e.target.closest('.filter .button');

        if (slider && slider.swiper && clickedFilterButton) {
            let filterButtons = gallery.querySelectorAll('.filter .button');
            let filter = clickedFilterButton.dataset.location || 'all';

            filterButtons.forEach(filterButton => {
                filterButton === clickedFilterButton ? filterButton.classList.add('is--active') : filterButton.classList.remove('is--active');
            });

            if (filter) {
                slider.swiper.removeAllSlides();

                slider.elements.forEach(slide => {
                    let image = slide.querySelector('.image');

                    if (image) {
                        let slideFilter = image.dataset.location || false;

                        if (filter === 'all' || slideFilter === filter) {
                            slider.swiper.appendSlide(slide);
                        }
                    }
                });
            }
        }

    }
  })

  if (!window.testEnvironment && !window.widgetEnvironment){
      window.CookieConsent = null
      CookieConsent()
      window.cc = new window.CookieConsent({
        title: "Wir verwenden Cookies 🍪",
        description: `Wir verwenden Cookies. Viele sind notwendig, um die Website und ihre Funktionen zu betreiben, andere sind für statistische oder Marketingzwecke. Mit der Entscheidung "Ablehnen" werden wir Ihre Privatsphäre respektieren und keine Cookies setzen, die nicht für den Betrieb der Seite notwendig sind.`,
        buttons: {
          acceptAll: "Alle akzeptieren",
          acceptSelected: "akzeptieren",
          reject: "Ablehnen",
          showSettings: "Cookie Einstellungen",
          hideSettings: "Schließen",
        },
        categories: {
          essentials: {
            label: "Essentiell",
            description: `Essenzielle Cookies ermöglichen grundlegende Funktionen und sind für die einwandfreie Funktion der Website erforderlich.`,
            checked: true,
            mandatory: true
          },
          analytics: {
            label: "Statistik",
            description: `Statistik-Cookies helfen Webseiten-Besitzern zu verstehen, wie Besucher mit Webseiten interagieren, indem Informationen anonym gesammelt und gemeldet werden.`,
            checked: true,
            mandatory: true
          }
        },
      })
    window.cc.on("change", (cc) => {
      updateAnalytics()
    })


    updateAnalytics()
  }

  const dataLayerTag = document.getElementById("datalayer")
  if (dataLayerTag && dataLayerTag.dataset.data){
    const dataLayerTagData = JSON.parse(dataLayerTag.dataset.data)
    window.dataLayer && dataLayer.push(dataLayerTagData);
    if (typeof fbq !== "undefined") fbq('track', dataLayerTagData.event, dataLayerTagData);
  }

  window.buildTooltip()

  let languageSwitcher = document.querySelector('select#language-switcher');
  if(languageSwitcher) {
      languageSwitcher.addEventListener('change', () => {
          var queryParams = new URLSearchParams(window.location.search);
          queryParams.set('lang', languageSwitcher.value);
          window.location.search = queryParams.toString();
      });
  }

  const cityToggle = document.getElementById('city-toggle');
  const cityMenue = document.getElementById('citymenue');
  const closeBtn = cityMenue ? cityMenue.querySelector('.is--close') : null;
  const headerElement = document.querySelector('header');

  const closeCityMenu = () => {
      cityMenue.classList.remove('is--open');
      cityToggle.classList.remove('is--active');
      if (headerElement && window.scrollY <= 50) {
          headerElement.classList.remove('is--small');
      }
  };

  if (cityToggle && cityMenue) {
      cityToggle.addEventListener('click', (e) => {
          e.stopPropagation();
          const isOpening = !cityMenue.classList.contains('is--open');
          cityMenue.classList.toggle('is--open');
          cityToggle.classList.toggle('is--active');

          if (isOpening && headerElement) {
              headerElement.classList.add('is--small');
          } else if (!isOpening) {
              closeCityMenu();
          }
      });

      document.addEventListener('click', (e) => {
          if (!cityMenue.contains(e.target) && !cityToggle.contains(e.target)) {
              closeCityMenu();
          }
      });

      document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
              closeCityMenu();
          }
      });

      const cityLinks = cityMenue.querySelectorAll('a');
      cityLinks.forEach(link => {
          link.addEventListener('click', (e) => {
              const chosenCity = document.getElementById('choosencity');
              if (chosenCity) {
                  chosenCity.textContent = link.textContent;
              }
              closeCityMenu();
          });
      });
  }
  if (closeBtn) {
      closeBtn.addEventListener('click', () => {
          closeCityMenu();
      });
  }

  let sliders = document.querySelectorAll('.swiper, .swiper-container');

  sliders.forEach(slider => {
      setTimeout(() => {
          let swiperWrapper = false;
          let prevButton = false;
          let nextButton = false;
          let pagination = false;
          let gallery = slider.closest('.gallery') ? true : false;
          let hasDifferentSizes = slider.classList.contains('has--different-sizes');

          for (let i = 0; i < slider.children.length; i++) {
              let child = slider.children[i];

              if (child.classList.contains('is--prev')) {
                  prevButton = child;
              } else if (child.classList.contains('is--next')) {
                  nextButton = child;
              } else if (child.classList.contains('swiper-pagination')) {
                  pagination = { el: child, clickable: true };
              } else if (child.classList.contains('swiper-wrapper')) {
                  swiperWrapper = child;
              }
          }

          if (swiperWrapper && swiperWrapper.childNodes.length > 0) {
              gallery === true ? slider.elements = [] : null;

              for (let i = 0; i < swiperWrapper.children.length; i++) {
                  let swiperSlide = swiperWrapper.children[i];
                  swiperSlide.classList.add('swiper-slide');
                  gallery === true ? slider.elements.push(swiperSlide) : null;

              }

              let swiperWrapperComputedStyle = getComputedStyle(swiperWrapper);
              let columnsMobile = swiperWrapperComputedStyle.getPropertyValue('--columns-mobile') ? parseInt(swiperWrapperComputedStyle.getPropertyValue('--columns-mobile').trim()) : 1;
              let columnsTablet = swiperWrapperComputedStyle.getPropertyValue('--columns-tablet') ? parseInt(swiperWrapperComputedStyle.getPropertyValue('--columns-tablet').trim()) : 2;
              let columnsDesktop = swiperWrapperComputedStyle.getPropertyValue('--columns-desktop') ? parseInt(swiperWrapperComputedStyle.getPropertyValue('--columns-desktop').trim()) : 3;
              let gapMobile = swiperWrapperComputedStyle.getPropertyValue('--gap-mobile') ? parseInt(swiperWrapperComputedStyle.getPropertyValue('--gap-mobile').trim()) : 16;
              let gapTablet = swiperWrapperComputedStyle.getPropertyValue('--gap-tablet') ? parseInt(swiperWrapperComputedStyle.getPropertyValue('--gap-tablet').trim()) : 24;
              let gapDesktop = swiperWrapperComputedStyle.getPropertyValue('--gap-desktop') ? parseInt(swiperWrapperComputedStyle.getPropertyValue('--gap-desktop').trim()) : 32;

              let rewind = slider.classList.contains('is--loop');
              let autoHeight = slider.classList.contains('is--autoheight'); // added 08.04.2025
              let centeredSlides = slider.classList.contains('is--transslides'); // für zentrierte Slides
              let navigation = !prevButton && !nextButton ? false : { prevEl: prevButton, nextEl: nextButton };
              let autoplay = slider.dataset.autoplay ? { delay: parseInt(slider.dataset.autoplay) } : false;

              let options = {
                  slidesPerView: columnsMobile,
                  spaceBetween: gapMobile,
                  watchSlidesProgress: true,
                  pagination,
                  navigation,
                  rewind,
                  autoplay,
                  autoHeight, // added 08.04.2025
                  centeredSlides, // für zentrierte Slides
                  breakpoints: {
                      640: {
                          slidesPerView: columnsTablet,
                          spaceBetween: gapTablet,
                      },
                      1024: {
                          slidesPerView: columnsDesktop,
                          spaceBetween: gapDesktop,
                      },
                  },
                  keyboard: {
                      enabled: true
                  }
              };

              if (gallery === true) {
                  options.grid = {
                      fill: 'column',
                      rows: 2
                  };
              }

              if (hasDifferentSizes === true) { // custom layout for different slide sizes (Partner Logos)
                  if (window.innerWidth >= 1024) {
                      // Das CSS steuert das Grid-Layout. JS muss nur die Positionen zuweisen.
                      delete options.breakpoints;
                      options.slidesPerView = 'auto'; // Erlaubt den Slides, ihre vom Grid vorgegebene Breite zu nutzen.
                      options.allowTouchMove = false; // Deaktiviert das Swipen, da es ein statisches Grid ist.
                      options.pagination = false; // Paginierung wird bei diesem Grid nicht benötigt.

                      // Event, um die Grid-Positionen nach der Swiper-Initialisierung zuzuweisen.
                      options.on = {
                          init: function (swiper) {
                              let row = 1;

                              // .is--first-order: volle Breite, eigene Zeile
                              const firstOrderSlides = swiper.slides.filter(slide => slide.classList.contains('is--first-order'));
                              firstOrderSlides.forEach(slide => {
                                  slide.style.gridColumn = '1 / span 4';
                                  slide.style.gridRow = row;
                                  row++;
                              });

                              // .is--second-order: immer 2 pro Zeile, je 2 Spalten
                              const secondOrderSlides = swiper.slides.filter(slide => slide.classList.contains('is--second-order'));
                              for (let i = 0; i < secondOrderSlides.length; i += 2) {
                                  if (secondOrderSlides[i]) {
                                      secondOrderSlides[i].style.gridColumn = '1 / span 2';
                                      secondOrderSlides[i].style.gridRow = row;
                                  }
                                  if (secondOrderSlides[i + 1]) {
                                      secondOrderSlides[i + 1].style.gridColumn = '3 / span 2';
                                      secondOrderSlides[i + 1].style.gridRow = row;
                                  }
                                  row++;
                              }

                              // .is--third-order: immer 4 pro Zeile, je 1 Spalte
                              const thirdOrderSlides = swiper.slides.filter(slide => slide.classList.contains('is--third-order'));
                              for (let i = 0; i < thirdOrderSlides.length; i += 4) {
                                  for (let j = 0; j < 4; j++) {
                                      if (thirdOrderSlides[i + j]) {
                                          thirdOrderSlides[i + j].style.gridColumn = `${j + 1} / span 1`;
                                          thirdOrderSlides[i + j].style.gridRow = row;
                                      }
                                  }
                                  row++;
                              }
                          }
                      };
                  }
              }


              let mapContainer = slider.closest('.map-container');

              if (mapContainer) {
                  options.on = {
                      slideChange: (e) => {
                          let mapButton = e.slides[e.activeIndex].querySelector('[data-location]');

                          if (mapButton) {
                              setActiveLocation(mapContainer, mapButton);
                          }
                      }
                  }
              }
              slider.swiper = new Swiper(slider, options);
          }
      }, 1000);
  });

  function atobUTF8(data) {
      const decodedData = atob(data);
      const utf8data = new Uint8Array(decodedData.length);
      const decoder = new TextDecoder("utf-8");
      for (let i = 0; i < decodedData.length; i++) {
          utf8data[i] = decodedData.charCodeAt(i);
      }
      return decoder.decode(utf8data);
  }

  function startLoading() {
    const loader = document.querySelector(".loader");
    if (!loader) return;

    loader.classList.add("active");

    setTimeout(() => {
        loader.classList.remove("active");
    }, 30000);

  }

  document.querySelectorAll(".travelDates").forEach((element) => {
    const csrfToken = document.getElementsByName("csrf-token")[0].content
    const params = {
      lang: element.dataset.lang
    }
    const options = {
      method: "POST",
      body: JSON.stringify(params),
      headers: {
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/json",
        "Accept": "application/json",
      }
    }

    fetch("/api/travel/_dates", options).then(r => r.text()).then(html => {
      element.style.display = "grid"
      if (element.innerHTML.startsWith("<path>")){
        let html1 = element.innerText.replaceAll("<path>", "")
        html1 = html1.replaceAll("</path>", "")
        html1 = html1.replaceAll("\n", "")
        let locals = html1.split(";").map( x => x.split(":"))
        locals.forEach(x => {
          html = html.replaceAll(atobUTF8(x[0]), x[1])
        })

      }
      element.innerHTML = html

      if (document.URL.indexOf("date=") != -1 || document.URL.indexOf("package=") != -1){
        const element = document.getElementById("travelForm");
        element.scrollIntoView();
      }


    })
  });

  document.querySelectorAll("input[name='order[payment_method]']").forEach((input) => {
    input.addEventListener('change', (event) => {
      if(event.target.id == "order_payment_method_creditcard"){
        document.querySelector('#iframe').style.display = "block"
      }else{
        document.querySelector('#iframe').style.display = "none"
      }
    });
    if (input.value == "creditcard" && input.checked){
      document.querySelector('#iframe').style.display = "block"
    }
  });
  const IFRAME_ORIGIN = 'https://cc.secupay.com';
  const iframeElement = document.getElementById('iframe');
  if (iframeElement){
    const iframeContentWindow = iframeElement.contentWindow;
    const form = document.getElementById("checkoutform")
    let submitPending = false;
     
    window.addEventListener('message', function (e) {
      if (e.origin !== IFRAME_ORIGIN) {
        console.warn('bad origin ' + e.origin);
        return;
      }
     
      switch(e.data.action) {
         
        case 'cc-iframe-height':
          iframeElement.height = e.data.documentHeight + 20 + 'px';
          break;
         
        case 'prepared-cc-data':
          if (!submitPending) break;
          submitPending = false;

          if (e.data.data.allFieldsAreValid){
            const payment_object = {
              owner: e.data.data.owner.value,
              pan: e.data.data.cardNumber.value,
              expiration_date: `${e.data.data.yearExp.value}-${e.data.data.monthExp.value}-01T00:00:00+00:00`,
              issuer: e.data.data.cardNumber.company,
              transact_container: e.data.data.encryptedData.crypted_container,
              transact_skey_pubkey: e.data.data.encryptedData.crypted_skey,
              transact_skey_keyname: e.data.data.encryptedData.key_filename,
              transact_hash: e.data.data.encryptedData.container_hash
            }
            document.querySelector('#order_payment_data').value = btoa(JSON.stringify(payment_object))
            startLoading();
            form.submit()
          } else {
            document.querySelector('#order_payment_data').value = ""
            document.querySelector('#iframe').scrollIntoView({
              behavior: "smooth"
            });
          }
          break;
         
        default:
          break;
      }
    }, false);
    if (form){
      form.addEventListener("submit", (event) => {
        if (document.querySelector('#iframe').style.display != "block") {
          startLoading();
          return;
        }

        event.preventDefault();
        if (submitPending) return;
        submitPending = true;

        iframeContentWindow.postMessage({ action: "get-cc-data" }, IFRAME_ORIGIN);
      });
    }
  }

  let menuToggle = document.querySelector('#menu-toggle');
  let menu = document.querySelector('#menu');

  if(menuToggle && menu) {
      let closeButton = menu.querySelector('button.is--toggle');
      let menuItems = menu.querySelectorAll('nav ul li a');

      menuToggle.addEventListener('click', () => {
          menu.classList.toggle('is--active');
      })

      if(closeButton) {
          closeButton.addEventListener('click', () => {
              menu.classList.toggle('is--active');
          })
      }

      if(menuItems) {
          menuItems.forEach(menuItem => {
              menuItem.addEventListener('click', () => {
                  menu.classList.toggle('is--active');
              })
          });
      }
  }


  let pagetitles = document.querySelectorAll('.pagetitle');
  pagetitles.forEach(title => {
    document.querySelector("title").innerText = title.innerText
  })

  let countdowns = document.querySelectorAll('.countdown');

  function setCountdown(countdown, countDownDate, x) {
    let now = new Date().getTime();
    let distance = countDownDate - now;

    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

    countdown.innerHTML = days + "D " + hours + "H "
    + minutes + "M " + seconds + "S ";

    if (distance < 0) {
      if (x) clearInterval(x);
      countdown.innerHTML = "Abgelaufen";
    }
  }

  if(countdowns) {
    countdowns.forEach(countdown => {
      let countDownDate = new Date(countdown.dataset.date).getTime();
      setCountdown(countdown, countDownDate)
      let x = setInterval(function() {
        setCountdown(countdown, countDownDate, x)
      }, 1000);
    })
  }




  let counters = document.querySelectorAll('.counter');

  if(counters) {
      counters.forEach(counter => {
          let counterInput = counter.querySelector('input');
          let counterButtonMinus = counter.querySelector('.btn.is--minus');
          let counterButtonPlus = counter.querySelector('.btn.is--plus');

          if(counterInput && counterButtonMinus && counterButtonPlus) {
              let counterInputStep = counterInput.step ? parseFloat(counterInput.step) : 1;
              let counterInputMin = counterInput.min ? parseFloat(counterInput.min) : 0;
              let counterInputMax = counterInput.max ? parseFloat(counterInput.max) : 100;

              counterButtonMinus.addEventListener('click', () => {
                  let counterInputValue = parseFloat(counterInput.value);

                  if(counterInputValue > counterInputMin) {
                      counterInput.value = parseFloat(counterInput.value) - counterInputStep;
                  }
              })

              counterButtonPlus.addEventListener('click', () => {
                  let counterInputValue = parseFloat(counterInput.value);
                  
                  if(counterInputValue < counterInputMax) {
                      counterInput.value = parseFloat(counterInput.value) + counterInputStep;
                  }
              })
          }
      });
  }

  if (location.hash) {
    let target = document.querySelector(location.hash);
    let source = document.querySelector('a[href="'+location.hash+'"]')
    if (target) {
      setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth' });
      }, 500);
      setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth' });
      }, 1000);
    }else if (source && source.role == "tab"){
      let tabs = source.closest('.tabs');
      if (tabs) setActiveTab(tabs, parseInt(location.hash.split("-")[1]));
    }
  }

  let hasIntolerances = document.querySelectorAll('#exclusive_invitation_has_intolerances');

  if(hasIntolerances) {
    hasIntolerances.forEach(check => {
      if (check.checked){
        document.querySelector('#exclusive_invitation_intolerances_content').style.display = "block"
      } else{
        document.querySelector('#exclusive_invitation_intolerances_content').style.display = "none"
      }
      check.addEventListener('change', (e) => {
        if (check.checked){
          document.querySelector('#exclusive_invitation_intolerances_content').style.display = "block"
        } else{
          document.querySelector('#exclusive_invitation_intolerances_content').style.display = "none"
        }
      })
    });
  }

  let specialCodes = document.querySelectorAll('.special_code');
  specialCodes.forEach(input => {
    input.addEventListener('input', (e) => {
      let submitButton = input.parentNode.parentNode.querySelector('.ticket-submit')
      let disabledButton = input.parentNode.parentNode.querySelector('.is--disabled')

      const formData1 = new FormData(submitButton.parentNode)
      fetch("/codecheck.json", {
        body: formData1,
        method: "PATCH"
      }).then(res => res.json()).then(data =>{
        if(data.valid){
          disabledButton.classList.add("is--hidden")
          submitButton.classList.remove("is--hidden")
        }else{
          disabledButton.classList.remove("is--hidden")
          submitButton.classList.add("is--hidden")
        }

      })

    })
  })



  let inputWrappers = document.querySelectorAll('.input-wrapper');

  if(inputWrappers) {
      inputWrappers.forEach(inputWrapper => {
          let input = inputWrapper.querySelector('input, select, textarea');
          let label = inputWrapper.querySelector('label.is--floating');

          if(label && input) {
              if(input.value) {
                  label.classList.add('is--active');
              } else {
                  label.classList.remove('is--active');
              }

              input.addEventListener('focus', () => {
                  label.classList.add('is--active');
              })

              input.addEventListener('focusout', () => {
                  if(input.value) {
                      label.classList.add('is--active');
                  } else {
                      label.classList.remove('is--active');
                  }
              })
          }
      });
  }

  let ticketButtons = document.querySelectorAll('.ticket .ticket-submit');
  let animationDuration = 850;

  if(ticketButtons) {
      ticketButtons.forEach(ticketButton => {
          ticketButton.style.setProperty("--transition-duration", animationDuration + 'ms');

          ticketButton.addEventListener('click', (e) => {
              e.preventDefault();
              ticketButton.classList.add('animation--play');
              ahoy.track("Add", {product_id: ticketButton.dataset.product});
              const formData = new FormData(ticketButton.parentNode)
              fetch(ticketButton.parentNode.getAttribute("action")+".json", {
                body: formData,
                method: "PATCH"
              }).then(res => res.json()).then(data =>{
                document.querySelector('.indicator').innerText = data.count
                document.querySelector('.indicator').style.display = "flex"

                window.dataLayer && dataLayer.push({event: 'add_to_cart', value: data.amount||0, currency: 'EUR'});

                if (typeof fbq !== "undefined") fbq('track', 'add_to_cart', {value: data.amount||0, currency:'EUR'});

                if (data.redirect_to) window.location = data.redirect_to
              });
              setTimeout(() => {
                  ticketButton.classList.remove('animation--play');
                  // ticketButton.parentNode.submit()
              }, animationDuration);
          })
      });
  }

  let advanceSalesStandSearch = document.querySelector('input#advance_sales_stand_search');
  let advanceSalesStandTable = document.querySelector('table#advance_sales_stands');

  if(advanceSalesStandSearch && advanceSalesStandTable) {
      let advanceSalesStandTableRows = advanceSalesStandTable.querySelectorAll('tbody tr');

      if(advanceSalesStandTableRows) {
          advanceSalesStandSearch.addEventListener('input', () => {
              let regex = new RegExp(advanceSalesStandSearch.value, 'gi');
              ahoy.track("advanceSalesStandSearch", {q: advanceSalesStandSearch.value});

              advanceSalesStandTableRows.forEach(advanceSalesStandTableRow => {
                  let counter = 0;
                  let advanceSalesStandTableRowCells = advanceSalesStandTableRow.querySelectorAll('th, td');

                  if(advanceSalesStandTableRowCells) {
                      advanceSalesStandTableRowCells.forEach(advanceSalesStandTableRowCell => {
                          if(advanceSalesStandTableRowCell.textContent.match(regex) && advanceSalesStandSearch.value != "") {
                              counter++;
                          }
                      });
                  }

                  if(counter > 0 || advanceSalesStandSearch.value == "") {
                      advanceSalesStandTableRow.classList.remove('is--hidden');
                  } else {
                      advanceSalesStandTableRow.classList.add('is--hidden');
                  }
              });
          })
      }
  }

  let verticalAccordionBlocks = document.querySelectorAll('.harmonica-accordion-container');

  if (verticalAccordionBlocks) {
      verticalAccordionBlocks.forEach(block => {
          let verticalAccordions = block.querySelectorAll('.harmonica-accordion');

          if (verticalAccordions) {
              verticalAccordions.forEach(accordion => {
                  let summary = accordion.querySelector('summary');

                  if (summary) {
                      summary.addEventListener('click', () => {
                          verticalAccordions.forEach(verticalAccordion => {
                              if (verticalAccordion != accordion) {
                                  verticalAccordion.open = false;
                              }
                          });
                      });
                  }
              });
          }
      });
  }
  const header = document.querySelector('header');
  window.addEventListener('scroll', () => {
      header.classList.toggle('is--small', window.scrollY > 50);
  });
  
  let lightboxElements = document.querySelectorAll('.interaction--enlarge');
  var galleryContainerLightboxes = [];
  let settings = {
      history: false,
      uniqueImages: false,
      captionSelector: 'self',
      navText: [
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z"/></svg>',
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M273 239c9.4 9.4 9.4 24.6 0 33.9L113 433c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l143-143L79 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L273 239z"/></svg>'
      ],
      closeText: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"/></svg>',
  };

  lightboxElements.forEach(lightboxElement => {
      let galleryContainer = lightboxElement.closest('.is--gallery, .slider');

      if (galleryContainer) {
          !galleryContainerLightboxes.includes(galleryContainer) ? galleryContainerLightboxes.push(galleryContainer) : null;
      } else {
          lightboxElement.lightbox = new SimpleLightbox(lightboxElement, settings);
      }
  });

  if (galleryContainerLightboxes.length > 0) {
      galleryContainerLightboxes.forEach(galleryContainerLightbox => {
          let galleryItems = galleryContainerLightbox.querySelectorAll('.interaction--enlarge');

          galleryContainerLightbox.lightbox = new SimpleLightbox(galleryItems, settings);
          Array.from(galleryItems).every(galleryItem => { galleryItem.lightbox = galleryContainerLightbox.lightbox; });
      });
  }

}

